var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Bare-mode display state for the ChatGPT embed PoC (see CONTRACT.md, Seam A).
 *
 * `?embed=1` puts the client in bare mode (3D only, no configurator panel).
 * The parent can later send `displayMode: "fullscreen"` to show the real
 * panel; any other mode hides it again. Kept as a tiny module-level store
 * so both the postMessage listener and the React tree can reach it.
 */
import { useEffect, useState } from "react";
var listeners = new Set();
var panelVisible = false;
var embedModeOverride;
var embedModeFromUrl;
function readEmbedModeFromUrl() {
    var _a;
    if (typeof window === "undefined") {
        return false;
    }
    if (new URLSearchParams(window.location.search).get("embed") === "1") {
        return true;
    }
    /* The client's own Router keeps its query after the hash (`#/path?x=1`),
     * so accept that form as well. */
    var hashQuery = (_a = window.location.hash.split("?")[1]) !== null && _a !== void 0 ? _a : "";
    return new URLSearchParams(hashQuery).get("embed") === "1";
}
/**
 * Whether this page was opened as `?embed=1`. Evaluated once: the Router
 * rewrites the URL on section navigation (`origin + pathname + #/path`) and
 * drops the search string, so re-reading it later would flip the answer.
 */
export function isEmbedMode() {
    if (embedModeOverride !== undefined) {
        return embedModeOverride;
    }
    if (embedModeFromUrl === undefined) {
        embedModeFromUrl = readEmbedModeFromUrl();
    }
    return embedModeFromUrl;
}
/** Test hook; production code reads the URL. */
export function setEmbedModeOverride(value) {
    embedModeOverride = value;
}
export function isEmbedPanelVisible() {
    return panelVisible;
}
export function setEmbedPanelVisible(visible) {
    var e_1, _a;
    if (panelVisible === visible) {
        return;
    }
    panelVisible = visible;
    try {
        for (var listeners_1 = __values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
            var listener = listeners_1_1.value;
            listener();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function subscribe(listener) {
    listeners.add(listener);
    return function () {
        listeners.delete(listener);
    };
}
export function useEmbedPanelVisible() {
    /* React 17: no useSyncExternalStore; subscribe manually. */
    var _a = __read(useState(isEmbedPanelVisible()), 2), visible = _a[0], setVisible = _a[1];
    useEffect(function () { return subscribe(function () { return setVisible(isEmbedPanelVisible()); }); }, []);
    return visible;
}
